import React from 'react';

import Select, { Props as SelectProps } from '@/components/Select';

import ControlWrapper from './ControlWrapper';

export interface Props extends SelectProps {
  id: string;
  label: string;
  value: string;
  setValue: (value: string) => void;
  options?: Array<string | { label: string; value: string }>;
  inline?: boolean;
  gridArea?: string;
  wrapperStyle?: React.CSSProperties;
  isNew?: boolean;
}

function SelectControl({
  id,
  label,
  value,
  setValue,
  options = [],
  inline,
  gridArea,
  wrapperStyle,
  isNew,
  ...delegated
}: Props) {
  // Options can either be an array of strings, or an array of
  // objects in the shape { label: str, value: str }
  //
  // Update it to be consistent.
  const formattedOptions = options.map((opt) => {
    if (typeof opt === 'object') {
      return opt;
    }

    return {
      label: opt,
      value: opt,
    };
  });

  return (
    <ControlWrapper
      id={id}
      label={label}
      gridArea={gridArea}
      inline={inline}
      isNew={isNew}
      style={wrapperStyle}
    >
      <Select
        {...delegated}
        id={id}
        value={value}
        onChange={(ev) => setValue(ev.currentTarget.value)}
      >
        {formattedOptions.map(({ label, value }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </Select>
    </ControlWrapper>
  );
}

export default SelectControl;
